import { Trans } from "@lingui/react/macro";
import { type LucideIcon } from "lucide-react";
import Link from "next/link";
import { Button } from "@/components/ui/button";

interface ErrorPageProps {
  code: string;
  title: string;
  icon: LucideIcon;
}

export default function ErrorPage({ code, title, icon: Icon }: ErrorPageProps) {
  return (
    <div className="flex flex-col min-h-screen items-center justify-center bg-linear-to-br from-violet-900 to-slate-900 p-4">
      <div className="text-center text-white">
        <div className="mb-8 inline-flex rounded-full bg-black/50 p-4">
          <Icon className="h-12 w-12" />
        </div>
        <h1 className="mb-4 text-6xl font-bold">{code}</h1>
        <h2 className="mb-4 text-3xl font-semibold">{title}</h2>
      </div>

      <Button asChild>
        <Link href="/">
          <Trans>Go back home</Trans>
        </Link>
      </Button>
    </div>
  );
}
